export type WorkShiftGroupStatus = "created" | "matching" | "matched" | "failed" | "fixed";

export const getStatusLabel = (status: WorkShiftGroupStatus): string => {
  const statusLabels: Record<WorkShiftGroupStatus, string> = {
    created: "初期化済み",
    matching: "マッチング中",
    matched: "マッチング済み（未確定）",
    failed: "失敗",
    fixed: "マッチング済み（確定）",
  };
  return statusLabels[status] || status;
};

export const canChangeStatus = (status: WorkShiftGroupStatus): boolean => {
  return status === "matched" || status === "fixed";
};
